module.exports = __webpack_public_path__ + "img/9791185871493.fb193962.jpg";